// extracted by mini-css-extract-plugin
export default {"TwoDimsListFeature":"ws_a bie_b","TwoDimsListFeature__item":"ws_b bie_we","TwoDimsListFeature__item__text":"ws_c bie_vt"};